function setupPublicPath(publicPath) {
  __webpack_public_path__ = publicPath;
}

export { setupPublicPath as set };
